// The controls-strip inputs of an open-ended block, ported from the coffee block's
// calcControlsProps.
//
// Which view modes are offered, and what each one needs to pick from, comes from the family's own
// lib: the verbatim mode picks tags from the whole report, the tags mode picks a codebook from the
// question's own. Everything else is what the question is and what the page says.
//
// The coffee guarded each assignment with a deep-equal so the props kept their identity across
// renders; a builder returns a fresh bag every call, so that memoization belongs to the caller.

import {
  getModelValue,
  getSurveyCodeBooks,
  getSurveyVariables,
  getTagsList,
  isGuest
} from '@aytm/app/stats/lib/stat-page'
import { calcCloudFeatures } from '@aytm/app/stats/page/question-views/oe/lib/props/word-cloud'

// the question types whose controls pick from the answer variants
const ITEM_TYPES = ['cx', 'scx', 'mx', 'mp']

// What the active view mode gives the researcher to pick from.
const calcPickers = ({ viewMode, key, type, lib }) => {
  if ('verbatim' === viewMode) return { tagsList: getTagsList(), codeBooks: [] }
  if ('tags' === viewMode) return { tagsList: [], codeBooks: lib.getQuestionCodeBooks(key, type) }

  return { tagsList: [], codeBooks: [] }
}

export const calcControlsProps = ({
  questionId,
  questionKey,
  type,
  format,
  config,
  viewMode,
  answerVariants,
  disabled,
  questionChartMode,
  isVerbatimType,
  lib,
  handlers = {}
} = {}) => {
  const key = lib.getKey(questionKey, config)

  return {
    model: {
      id: questionId,
      key: questionKey,
      type,
      // codebooks read through their own reader: the generic variables reader falls back to an
      // object, which the verbatim search then iterates and throws on.
      survey: { tags: getSurveyVariables('tags') || {}, codeBooks: getSurveyCodeBooks() },
      config: config || lib.defaultConfig[viewMode] || {},
      ...calcPickers({ viewMode, key, type, lib }),
      items: (ITEM_TYPES.includes(type) && answerVariants) || null,
      chartMode: questionChartMode || getModelValue('chartMode'),
      viewMode
    },
    data: {
      controls: {
        viewModes: {
          options: lib.getViewModesOptions(key, type, format || {}),
          default: lib.getDefaultViewMode(key, type, format || {}),
          disabled: false
        },
        config: {
          verbatim: {
            preset: { options: lib.presetOptions, disabled: false },
            search: { disabled: false }
          }
        }
      }
    },
    features: calcCloudFeatures(),
    isVerbatimType,
    isSurveyGuest: isGuest(),
    disabled,
    onViewModeChange: handlers.onViewModeChange,
    onConfigChange: handlers.onConfigChange,
    onExport: handlers.onExport
  }
}
